import ConnectButton from "./ConnectButton";

export default function ConnectScreen() {
  return (
    <ConnectButton />
  );
}
